/** Permission keys issued in the access-token `permission` claim. */
export const Permissions = {
  ApplicationView: 'APPLICATION_VIEW',
  ApplicationSubmit: 'APPLICATION_SUBMIT',
  ApplicationReview: 'APPLICATION_REVIEW',
  ApplicationApprove: 'APPLICATION_APPROVE',
  ApplicationReject: 'APPLICATION_REJECT',
  ScholarshipCreate: 'SCHOLARSHIP_CREATE',
  ScholarshipEdit: 'SCHOLARSHIP_EDIT',
  ScholarshipDelete: 'SCHOLARSHIP_DELETE',
  UserManage: 'USER_MANAGE',
  RoleManage: 'ROLE_MANAGE',
  RoleAssign: 'ROLE_ASSIGN',
  FeatureToggleView: 'FEATURE_TOGGLE_VIEW',
  FeatureToggleManage: 'FEATURE_TOGGLE_MANAGE',
  ScholarshipTemplateView: 'SCHOLARSHIP_TEMPLATE_VIEW',
  ScholarshipTemplateManage: 'SCHOLARSHIP_TEMPLATE_MANAGE',
  FinanceManage: 'FINANCE_MANAGE',
  FlightRequestSubmit: 'FLIGHT_REQUEST_SUBMIT',
  FlightRequestView: 'FLIGHT_REQUEST_VIEW',
  FlightRequestReview: 'FLIGHT_REQUEST_REVIEW',
  FlightRequestBook: 'FLIGHT_REQUEST_BOOK',
  AwardView: 'AWARD_VIEW',
  AwardManage: 'AWARD_MANAGE',
  ExpenseView: 'EXPENSE_VIEW',
  ClaimSubmit: 'CLAIM_SUBMIT',
  ClaimView: 'CLAIM_VIEW',
  ClaimReview: 'CLAIM_REVIEW',
  ClaimPay: 'CLAIM_PAY',
  ProgressReportSubmit: 'PROGRESS_REPORT_SUBMIT',
  ReportsView: 'REPORTS_VIEW',
  EventRegister: 'EVENT_REGISTER',
  EventManage: 'EVENT_MANAGE',
  EventView: 'EVENT_VIEW',
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];

export const DotNetRoleClaim =
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
